<script lang="ts">
	import { __ } from '@wordpress/i18n';

	interface Props {
		open: boolean;
		onClose: () => void;
	}

	let { open, onClose }: Props = $props();

	function handleBackdropClick(e: MouseEvent) {
		if (e.target === e.currentTarget) {
			onClose();
		}
	}

	function handleKeydown(e: KeyboardEvent) {
		if (e.key === 'Escape') {
			onClose();
		}
	}
</script>

{#if open}
	<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
	<div
		role="dialog"
		aria-modal="true"
		tabindex="-1"
		onclick={handleBackdropClick}
		onkeydown={handleKeydown}
		style="position:fixed;inset:0;z-index:999999;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.4);padding:16px;"
	>
		<div style="position:relative;background:#fff;border-radius:16px;max-width:420px;width:100%;box-shadow:0 20px 60px rgba(0,0,0,0.15);font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;overflow:hidden;">
			<!-- Accent bar -->
			<div style="height:4px;background:linear-gradient(90deg,#06107a,#1a2a9a);"></div>

			<!-- Close button -->
			<div style="display:flex;justify-content:flex-end;padding:16px 20px 0 20px;">
				<button
					type="button"
					onclick={onClose}
					style="display:flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:8px;background:#f5f5f3;border:none;cursor:pointer;"
					aria-label={__('Sluiten', 'wpc')}
				>
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1L13 13M13 1L1 13" stroke="#888" stroke-width="1.8" stroke-linecap="round"/></svg>
				</button>
			</div>

			<!-- Content -->
			<div style="padding:8px 32px 12px 32px;">
				<h3 style="margin:0 0 6px;font-size:20px;font-weight:700;color:#1a1a1a;letter-spacing:-0.02em;line-height:28px;">
					{__('Oplage op aanvraag', 'wpc')}
				</h3>
				<p style="margin:0;font-size:14px;font-weight:400;color:#5a5a58;line-height:22px;">
					{__('Neem voor het aanvragen of bestellen van deze oplage svp contact op via:', 'wpc')}
				</p>
			</div>

			<!-- Contact cards -->
			<div style="display:flex;flex-direction:column;padding:0 32px;gap:10px;">
				<!-- Email -->
				<a href="mailto:office@wisa.nl" style="display:flex;align-items:center;gap:14px;padding:14px 18px;background:#f8f8f6;border-radius:10px;text-decoration:none;">
					<div style="display:flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:10px;background:#06107a;flex-shrink:0;">
						<svg width="18" height="14" viewBox="0 0 18 14" fill="none"><path d="M1.5 1L9 7.5L16.5 1" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><rect x="0.75" y="0.75" width="16.5" height="12.5" rx="2" stroke="white" stroke-width="1.5"/></svg>
					</div>
					<div>
						<div style="font-size:11px;font-weight:500;color:#8b8b8b;letter-spacing:0.06em;text-transform:uppercase;line-height:16px;">E-mail</div>
						<div style="font-size:15px;font-weight:500;color:#06107a;line-height:22px;">office@wisa.nl</div>
					</div>
				</a>
				<!-- Phone -->
				<a href="tel:+31534611515" style="display:flex;align-items:center;gap:14px;padding:14px 18px;background:#f8f8f6;border-radius:10px;text-decoration:none;">
					<div style="display:flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:10px;background:#06107a;flex-shrink:0;">
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6.2 7.4C6.8 8.6 7.8 9.6 9 10.2L10 9.2C10.2 9 10.4 8.9 10.7 9C11.5 9.3 12.3 9.4 13.2 9.4C13.6 9.4 14 9.8 14 10.2V13.2C14 13.6 13.6 14 13.2 14C6.5 14 1 8.5 1 1.8C1 1.4 1.4 1 1.8 1H4.8C5.2 1 5.6 1.4 5.6 1.8C5.6 2.7 5.8 3.5 6 4.3C6.1 4.6 6 4.8 5.8 5L4.8 6C5.1 6.5 5.6 7 6.2 7.4Z" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
					</div>
					<div>
						<div style="font-size:11px;font-weight:500;color:#8b8b8b;letter-spacing:0.06em;text-transform:uppercase;line-height:16px;">Telefoon</div>
						<div style="font-size:15px;font-weight:500;color:#06107a;line-height:22px;">+31 53 461 15 15</div>
					</div>
				</a>
			</div>

			<!-- Footer -->
			<div style="display:flex;justify-content:center;padding:20px 32px 28px 32px;">
				<button
					type="button"
					onclick={onClose}
					style="display:flex;align-items:center;justify-content:center;padding:10px 32px;background:#009ee3;color:#fff;border:none;border-radius:8px;font-size:13px;font-weight:500;cursor:pointer;letter-spacing:0.01em;"
				>
					{__('Sluiten', 'wpc')}
				</button>
			</div>
		</div>
	</div>
{/if}
